import React, { useState } from 'react';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import Logo from '@/Shared/Logo';
// import MainMenu from '@/Shared/MainMenu';
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import PrimaryMenu from '@/Shared/Layouts/Menus/PrimaryMenu';
import UserDropdown from '@/Shared/Layouts/Headers/UserDropdown';
import SearcherHeader from '@/Shared/Layouts/Headers/SearcherHeader';
import { useProps } from '@/Shared/FuncComp';
import Auth from '@/constants/Auth';
import CartIcon from '@/Shared/Cartera/CartIcon'
import MainSocialMenu from '@/Shared/Layouts/Menus/MainSocialMenu';

export default () => {
	const {auth} = useProps();
	const [openSearch, setSearch] = React.useState(false);
	// const [menuOpened, setMenuOpened] = useState(false);
	return <Navbar bg="white" variant="light" expand="lg">
		<Container className="justify-content-around">
			<Navbar.Brand as={InertiaLink} href={route('inicio')} ><Logo /></Navbar.Brand>
			<div className={"w-100 my-2 mr-2"}><SearcherHeader show={openSearch} setShow={setSearch} btnProps={{className: "border-0"}} searchProps={{className: "border-left-0"}} /></div>
			<Navbar.Toggle aria-controls="navbar-common" />
			<Navbar.Collapse id="navbar-common" className={"justify-content-end text-primary"+(openSearch?' collapse':'')}>
				{<><PrimaryMenu className="mr-2" /*prepend={[
					{
						name: <SearcherHeader />,
						props: {
							as: 'li',
							href: undefined,
						}
					}
				]}*/ />
				<MainSocialMenu className="mr-2" /></>}
			</Navbar.Collapse>
			<Nav className="ml-auto align-items-center">
				<CartIcon />
				{Auth.isLogged() && <UserDropdown className="ml-3" />}
			</Nav>
		</Container>
	</Navbar>;
}
